import React from "react";

function SectionApropos() {
  return (
    <>
      <section class="container-white competence">
        <div class="competence-body">
          <div class="row">
            <div class="col-md-12 description margin_60_0">
              <h1 class="add_top_30 add_bottom_30">Infos</h1>
              <p>
                J'ai littéralement 20 secondes pour vous donner envie de lire la
                suite. La pression. Du coup, je vais aller droit au but. Aussi,
                longtemps, que je m'en souvienne j'ai toujours été passionné par
                le web : du réseau en passant par le développement. Autodidacte
                et ayant la soif d'apprendre, je compte plus les heures passées
                et que je passe encore aujourd'hui devant mon Pc à me former sur
                les dernières technologies du web. Cela m'a permis de pouvoir
                décrocher et développer des projets d'envergure, et tout cela en
                dehors de mon job en réseau, un vrai bosseur direz-vous ? Oui et
                non, plutôt un bosseur passionné. Comment ça ? Ça continue en
                dessous.
              </p>
              <br />
              <p>
                Mon amour pour le code a commencé en 2015, pendant mes études,
                je prospectais certaines entreprises de ma ville pour pouvoir
                les aider sur leurs projets web. J'ai donc réalisé mes premiers
                développements de site internet : pour une association sportive
                et un artisan fleuriste. De fil en aiguille et d'année en année,
                le code est devenu une vraie "Love story". J'ai acquis de
                nouvelles compétences, en recherchant sans cesse à développer un
                code le plus propre possible et optimisé. Je me suis formé sur
                les dernières technologies et j'ai pu développer des sites
                internet plus qu'intéressant (site de voyage, site e-commerce,
                réseau social, ...) mais aussi une application mobile qui est en
                cours de développement pour IOS et Play Store. Vous l'auriez
                compris débugger et le goût du développement ça je kiff ! Avec
                mes compétences en réseaux et mes études en systèmes, je forme
                un réel package 2.0.
              </p>
              <br />
              <p>
                Vous voulez échanger avec moi sur mon parcours ou sur un projet
                en particulier ? Avec grand plaisir on se retrouve ici !
                <a href="https://bit.ly/38l44b9" class="to_black">
                  https://bit.ly/38l44b9
                </a>
              </p>
            </div>
            <div class="col-md-12 description margin_60">
              <h1 class="add_top_30 add_bottom_30">FORMATIONS</h1>
              <h2 class="margin_30">
                BTS Services Informatiques aux Organisations (SIO)
              </h2>
              <p>
                - Mise en place et configuration de différents réseaux. -
                Création d'un site internet (forum en ligne) et site supervision
              </p>
              <h2 class="margin_30">
                Licence informatique en 1ère année d’études supérieures
              </h2>
              <p>
                - Connaissances générales de l’informatique : structures de
                données, de langages C/Java,...
              </p>
              <h2 class="margin_30">Baccalauréat Technologique STMG </h2>
              <p>
                - Développement d’un site Internet pour une association sportive
                et un artisan fleuriste.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SectionApropos;
